import { createAction } from '@reduxjs/toolkit';
import { OtpSetStatePayload } from './otp.types';

/**
 * Sets the state for the otp
 */
export const setOtpStateAction = createAction<
  OtpSetStatePayload,
  'otp/SET_STATE'
>('otp/SET_STATE');

export const setGenerateOtpStateAction = createAction<
  OtpSetStatePayload & { jwt: string | null },
  'otp/SET_GENERATE_STATE'
>('otp/SET_GENERATE_STATE');

export const resetOtpErrorsAction = createAction('otp/RESET_ERRORS');

export const resetOtpStateAction = createAction('otp/RESET_STATE');
